import {
  GET_PAYU_FAILED,
  GET_PAYU_REQUESTED,
  GET_PAYU_RESPONSE_FAILED,
  GET_PAYU_RESPONSE_REQUESTED,
  GET_PAYU_RESPONSE_SUCCESS,
  GET_PAYU_SUCCESS,
} from "resources/actionTypes";

const intialState = {
  userPayu: [],
  loading: false,
  error: null,
};
const intialStateResponse = {
  userPayuResponse: [],
  loading: false,
  error: null,
}
export function userPayu(state = intialState, action) {
  switch (action.type) {
    case GET_PAYU_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_PAYU_SUCCESS:
      return {
        ...state,
        loading: false,
        userPayu: action.userPayu,
      };
    case GET_PAYU_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
export function userPayuResponse(state = intialStateResponse, action) {
  switch (action.type) {
    case GET_PAYU_RESPONSE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_PAYU_RESPONSE_SUCCESS:
      return {
        ...state,
        loading: false,
        userPayuResponse: action.userPayuResponse,
      };
    case GET_PAYU_RESPONSE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
